export const DIRECT_DEAL_ACL_OBJECTS = [
    'DirectDealsDetail',
    'DirectDealsNew',
    'DirectDealsList'
];
